/**
 * Miro connector — single source of truth for all Miro metadata.
 * SVG source: https://github.com/simple-icons/simple-icons/blob/develop/icons/miro.svg
 */

module.exports = {
  id:          'miro',
  name:        'Miro',
  enabled:     false,
  iconBg:      '#050038',
  svgPath:     'M17.392 0H13.9L17 4.808 10.444 0H6.949l3.102 6.3L3.494 0H0l3.05 8.131L0 24h3.494L10.05 6.985 6.949 24h3.494L17 5.494 13.899 24h3.493L24 3.672 17.392 0z',

  tagline:     'Read workshop outputs, maps, and diagrams into agent context.',
  description: 'Connect Miro so agents can read collaborative workshop outputs — user journey maps, service blueprints, and strategic canvases — when reasoning about your product direction.',
  useCases: [
    'Pull journey maps and service blueprints into strategy context',
    'Read workshop outputs when agents assess problem framing',
    'Surface collaborative research artefacts in brief generation',
  ],
};
